<template>
  <div class="rf__parent" v-bind:class="{ 'mobile': this.$store.getters.isMobile }">
    <span class="filter-by">Filter By</span>
    <button
      class="rf__btn"
      v-bind:class="{ 'active': activeBtns.rfbQuote }"
      type="button"
      id="rfbQuote"
      @click="toggleBtn(this, $event)"
    >
      <svg class="icon icon-Quote">
        <use xlink:href="#icon-Quote" />
      </svg>
      <span>Quote</span>
    </button>
    <button
      class="rf__btn"
      v-bind:class="{ 'active': activeBtns.rfbOutcome }"
      type="button"
      id="rfbOutcome"
      @click="toggleBtn(this, $event)"
    >
      <svg class="icon icon-Info">
        <use xlink:href="#icon-Info" />
      </svg>
      <span>Outcome</span>
    </button>
    <button
      class="rf__btn"
      v-bind:class="{ 'active': activeBtns.rfbStory }"
      type="button"
      id="rfbStory"
      @click="toggleBtn(this, $event)"
    >
      <svg class="icon icon-Article">
        <use xlink:href="#icon-Article" />
      </svg>
      <span>Achievement Story</span>
    </button>
    <button
      class="rf__btn"
      v-bind:class="{ 'active': activeBtns.rfbVideo }"
      type="button"
      id="rfbVideo"
      @click="toggleBtn(this, $event)"
    >
      <svg class="icon icon-Play">
        <use xlink:href="#icon-Play" />
      </svg>
      <span>Video</span>
    </button>
    <span class="select-wrapper">
      <div class="select-wrapper__col select-wrapper__col--30">
        <select class="rf__select" v-on:change="toggleSelect(this, $event)">
          <option
            v-bind:key="region.index"
            v-for="region in regions"
            :selected="region == activeFilters.region"
            :value="region"
          >{{region}}</option>
        </select>
      </div>
      <div class="select-wrapper__col select-wrapper__col--40">
        <select class="rf__select" v-on:change="toggleSelectOrg(this, $event)">
          <option
            v-bind:key="organization.index"
            v-for="organization in organizations"
            :selected="organization == activeFilters.organization"
            :value="organization"
          >{{organization}}</option>
        </select>
      </div>
      <div class="select-wrapper__col select-wrapper__col--30">
        <div class="rf__text-wrapper">
          <input
            class="rf__text"
            v-model="searchInput"
            placeholder="Search..."
            type="text"
            @focus="showKeyboard = true"
          />
          <button type="button" name="button" @click="finishTextSearch">Go</button>
        </div>
      </div>
    </span>

    <div class="rf__keyboard-wrapper" v-if="!this.$store.getters.isMobile && showKeyboard">
      <div class="rf__keyboard-wrapper__content">
        <div class="rf__keyboard-close">
          <button>close</button>
        </div>
        <div class="rf__keyboard-wrapper__display">
          <input type="text" v-model="searchInput" placeholder="Search..." />
        </div>
        <keyboard
          v-model="searchInput"
          @custom="custom"
          @finishTextSearch="finishTextSearch"
          :layouts="[
            'qwertyuiop{delete:backspace}|asdfghjkl{clear:clear}{search:finishTextSearch}|{shift:goto:1}zxcvbnm!?{shift:goto:1}|{?123:goto:2}/{space:space}@{.com:custom},',
            'QWERTYUIOP{delete:backspace}|ASDFGHJKL{clear:clear}{search:finishTextSearch}|{shift:goto:0}ZXCVBNM!?{shift:goto:0}|{?123:goto:2}/{space:space}@{.com:custom},',
            '1234567890{delete:backspace}|-/:;()$&@{clear:clear}{search:finishTextSearch}|{#+=:goto:3}.,?!\'|{abc:goto:0}/{space:space}@{.com:custom},',
            '[]{{}}#%^+={delete:backspace}|_\\||~<>{clear:clear}{search:finishTextSearch}|{?123:goto:2}.,?!\'|{abc:goto:0}/{space:space}@{.com:custom},',
            ]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import EventBus from "../eventbus.js";
import Keyboard from "vue-keyboard";

export default {
  name: "ResultsFilter",
  props: ["updateCardsParent"],
  data() {
    return {
      filterActive: false,
      activeBtns: {
        rfbQuote: false,
        rfbOutcome: false,
        rfbStory: false,
        rfbVideo: false
      },
      filtersMap: {
        rfbQuote: "Qualitative Statement",
        rfbOutcome: "Quantified Statement",
        rfbStory: "Achievement Story",
        rfbVideo: "Video"
      },
      filtersMapRev: {
        "Qualitative Statement": "rfbQuote",
        "Quantified Statement": "rfbOutcome",
        "Achievement Story": "rfbStory",
        Video: "rfbVideo"
      },
      activeFilters: {
        offset: 0,
        asset_types: [],
        region: "All Locations",
        organization: "",
        textSearch: ""
      },
      // considered using filterBtns array but svg doesn't render if done by JS
      regions: ["All Locations"],
      organizations: ["Select Organization"],
      searchInput: "",
      showKeyboard: false
    };
  },
  created() {
    axios
      .get("/api/v1/organizations")
      .then(response => {
        // handle success
        const organizations = response;
        let orgs = [];

        organizations.data.map(function(organizations) {
          // this.regions.push(this);
          let org = organizations;

          if (org.indexOf(";") !== -1) {
            org.split(";").map(function(org) {
              if (orgs.indexOf(org) === -1) {
                org = org.trim();
                if (org) {
                  orgs.push(org);
                }
              }
            });
          } else {
            if (orgs.indexOf(org) === -1) {
              org = org.trim();
              if (org) {
                orgs.push(org);
              }
            }
          }
        });

        this.organizations = orgs.sort();
        this.organizations.unshift("All Organizations");
      })
      .catch(function(error) {
        console.log("failed to retreive organizations");
      });

    axios
      .get("/api/v1/regions")
      .then(response => {
        // handle success
        const regions = response;
        let regs = [];

        regions.data.map(function(regions) {
          // this.regions.push(this);
          let reg = regions.region; // dumb from controller
          if (reg.indexOf(";") !== -1) {
            reg.split(";").map(function(reg) {
              if (regs.indexOf(reg) === -1) {
                reg = reg.trim();
                if (reg && reg !== "All") {
                  regs.push(reg);
                }
              }
            });
          } else {
            if (regs.indexOf(reg) === -1) {
              reg = reg.trim();
              if (reg && reg !== "All") {
                regs.push(reg);
              }
            }
          }
        });

        this.regions = regs.sort();
        this.regions.unshift("All Locations");
      })
      .catch(function(error) {
        console.log("failed to retreive regions");
      });

    EventBus.$on("checkFiltersCustomDashboard", filters => {
      this.activeFilters = filters;
      this.updateButtonsFromState();
      this.updateCards();
      const newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname;
      window.history.pushState({ path: newurl }, "", newurl);
    });
  },
  mounted() {
    if (this.$store.getters.activeFilters) {
      this.activeFilters = this.$store.getters.activeFilters;
      this.searchInput = this.activeFilters.textSearch;
      this.updateButtonsFromState();
    }
    document.body.addEventListener("click", e => {
      if (
        e.target.closest(".vue-keyboard") === null &&
        e.target !== document.querySelector(".rf__parent") &&
        e.target !==
          document.querySelector(".rf__keyboard-wrapper__display input") &&
        this.showKeyboard === true
      ) {
        this.showKeyboard = false;
      }
    });

    document.body.addEventListener("keydown", e => {
      if (e.key === "Enter") {
        e.preventDefault();
        this.finishTextSearch();
      }
      if (e.key === "Escape") {
        e.preventDefault();
        this.showKeyboard = false;
      }
    });
  },
  // updated() {
  // },
  methods: {
    updateButtonsFromState() {
      let curActiveBtns = this.activeBtns,
        thisFiltersMapRev = this.filtersMapRev;

      // ugly backwards lookup
      if (this.activeFilters.asset_types) {
        this.activeFilters.asset_types.map(function(assetType) {
          curActiveBtns[thisFiltersMapRev[assetType]] = true;
        });
      }
    },
    checkActiveFilters() {
      const activeBtns = this.activeBtns;

      this.filterActive = false;

      for (const btnFilter in activeBtns) {
        if (activeBtns[btnFilter]) {
          this.filterActive = true;
        }
      }

      if (this.activeFilters.region !== "") {
        this.filterActive = true;
      }

      if (this.activeFilters.organization !== "") {
        this.filterActive = true;
      }
    },
    toggleBtn(elem, event) {
      let selectedBtn = event.target.id,
        curWindowWidth = window.innerWidth;

      if (!selectedBtn) {
        selectedBtn = $(event.target)
          .closest(".rf__btn")
          .attr("id");
      }

      if (selectedBtn === "undefined") {
        return;
      }

      this.activeBtns[selectedBtn] = !this.activeBtns[selectedBtn];

      if (typeof this.activeFilters.asset_types === "undefined") {
        this.activeFilters.asset_types = [];
      }

      if (this.activeBtns[selectedBtn]) {
        this.activeFilters.asset_types.push(this.filtersMap[selectedBtn]);

        if (this.$store.getters.isMobile) {
          // click document to prevent sticky active/hover styles
          if (curWindowWidth > 650 && curWindowWidth < 7680) {
            $(event.target)
              .closest(".rf__btn")
              .css("background-color", "white");
          } else {
            $(event.target)
              .closest(".rf__btn")
              .css("background-color", "black");
          }
        } else {
          $(event.target)
            .closest(".rf__btn")
            .css("background-color", "");
        }
      } else {
        this.activeFilters.asset_types = this.activeFilters.asset_types.filter(
          filter => filter !== this.filtersMap[selectedBtn]
        );

        if (this.$store.getters.isMobile) {
          // click document to prevent sticky active/hover styles
          $(event.target)
            .closest(".rf__btn")
            .css("background-color", "rgb(191, 203, 217)");
        } else {
          $(event.target)
            .closest(".rf__btn")
            .css("background-color", "");
        }
      }

      this.checkActiveFilters();
      this.updateCards();
    },
    toggleSelect(elem, event) {
      const activeRegion = event.target.value;
      this.activeFilters.region =
        activeRegion === "Select Region" ? "" : activeRegion;
      this.checkActiveFilters();
      this.updateCards();
    },
    toggleSelectOrg(elem, event) {
      const activeOrganization = event.target.value;
      this.activeFilters.organization =
        activeOrganization === "Select Organization" ? "" : activeOrganization;
      this.checkActiveFilters();
      this.updateCards();
    },
    finishTextSearch(elem, event) {
      // const activeSearchTerm = event.target.value;
      this.showKeyboard = false;
      this.activeFilters.textSearch = this.searchInput;
      console.log("search for: " + this.searchInput);
      this.updateCards();
    },
    updateCards() {
      this.updateCardsParent(this.activeFilters, this.filterActive, true);
    },
    custom() {
      return (this.input = this.input + ".com");
    }
  },
  components: {
    Keyboard
  }
};
</script>

<style scoped>
.rf__parent {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 0.5em;
}

span.filter-by {
  font-size: 1.5em;
  margin-right: 0.5em;
}

.rf__btn {
  background-color: rgb(191, 203, 217);
  padding: 10px 20px;
  border-radius: 5px;
  box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.1);
  color: white;
  margin-left: 0.5em;
}

.rf__btn.active {
  background-color: white;
  color: black;
}

.rf__btn:hover {
  background-color: white;
  color: black;
}

.rf__btn svg {
  margin-right: 0.5em;
}

.rf__select {
  padding: 6px 20px;
  -webkit-appearance: none;
  appearance: none;
  background-image: url("./../../img/chevron-down.svg");
  background-repeat: no-repeat;
  background-position: 100% center;
  background-color: white;
  border: 1px solid rgb(191, 203, 217);
  border-radius: 5px;
  width: 100%;
  font-size: 16px;
}

.rf__text-wrapper .rf__text {
  flex: 1 0 auto;
  padding: 6px 10px;
  -webkit-appearance: none;
  appearance: none;
  background-color: white;
  border: 1px solid rgb(191, 203, 217);
  border-radius: 5px;
  line-height: 16.8px;
  font-size: 16px;
}

.rf__text-wrapper button {
  flex: 0 0 auto;
  margin-left: 0.5em;
  padding: 6px 10px;
  -webkit-appearance: none;
  appearance: none;
  background-color: rgb(191, 203, 217);
  border: 1px solid rgb(191, 203, 217);
  margin-left: 0.5em;
  border-radius: 5px;
  line-height: 16.8px;
  color: white;
  cursor: pointer;
}

.rf__text-wrapper {
  display: flex;
  width: 100%;
}

.select-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px;
  width: calc(100% + 16px);
}

.select-wrapper__col {
  flex: 0 0 auto;
  padding: 0 8px;
  margin-top: 1em;
}

.select-wrapper__col--30 {
  width: 30%;
}

.select-wrapper__col--40 {
  width: 40%;
}

/* mobile styling */
.rf__parent.mobile {
  margin-top: calc(50px + 1em);
}

@media screen and (max-width: 650px) {
  .rf__parent.mobile .rf__btn span {
    display: none;
  }

  .rf__parent.mobile .rf__btn {
    padding: 10px;
    border-radius: 100%;
  }

  .rf__parent.mobile .rf__btn:hover {
    background-color: black;
    color: white;
  }

  .rf__parent.mobile .rf__btn.active {
    background-color: black;
    color: white;
  }

  .rf__parent.mobile .rf__btn .icon {
    margin: 0;
  }
}

@media screen and (max-width: 800px) {
  .select-wrapper .select-wrapper__col {
    width: 100%;
  }
}

.rf__keyboard-wrapper {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  /* bottom: 0; */
  height: 100vh;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.5);
}

.rf__keyboard-wrapper .rf__keyboard-wrapper__content {
  flex: 0 0 auto;
}
.rf__keyboard-wrapper__content {
  position: relative;
}
.rf__keyboard-wrapper .rf__keyboard-wrapper__display input {
  padding: 5px 10px;
  font-size: 20px;
  font-weight: 500;
  border: 0;
  width: 100%;
}
.rf__keyboard-close {
  position: absolute;
  top: -3rem;
  right: 0rem;
}
.rf__keyboard-close button {
  background: white;
  padding: 5px 10px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.178);
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ResultsFilter.vue